import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ProcessPage } from './pages/ProcessPage';
import { ResultsPage } from './pages/ResultsPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { RefundPage } from './pages/RefundPage';
import { PaymentConfirmedPage } from './pages/PaymentConfirmedPage';
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/4Z9hCxF9GbFsHJdtqTcfuJ/Captura_de_pantalla_2026-05-21_a_las_16.06.43.png';
export function App() {
  // Set browser tab title and favicon
  useEffect(() => {
    document.title = 'Growthly Corporation Systems';
    let description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.name = 'description';
      document.head.appendChild(description);
    }
    description.content = 'Growthly Corporation Systems diseña la presencia digital de negocios que quieren verse tan bien como trabajan.';
    const setFavicon = (rel: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = FAVICON_URL;
    };
    setFavicon('icon');
    setFavicon('shortcut icon');
    setFavicon('apple-touch-icon');
  }, []);
  return <Router data-id="element-0" data-mp="nv0xjrl9am4m">
      <div className="min-h-screen bg-black font-sans text-gray-100 selection:bg-white selection:text-black" data-id="element-1" data-mp="nvan5e2e2r9s">
        <SiteLayout data-id="element-2" data-mp="swglbretj6qp">
          <Routes data-id="element-3" data-mp="3686tkdjumw2">
            <Route path="/" element={<HomePage data-id="element-5" data-mp="34x1vh8db93d" />} data-id="element-4" data-mp="35oxgs1yt6tn" />
            <Route path="/servicios" element={<ServicesPage data-id="element-7" data-mp="3udaw269tuj3n" />} data-id="element-6" data-mp="38ktgau95lfg" />
            <Route path="/proceso" element={<ProcessPage data-id="element-9" data-mp="3uevui6z9im6s" />} data-id="element-8" data-mp="3ubztuaw15jen" />
            <Route path="/resultados" element={<ResultsPage data-id="element-11" data-mp="d3cw3t2oyyh3" />} data-id="element-10" data-mp="d57gn6a1wokn" />
            <Route path="/faq" element={<FAQPage data-id="element-13" data-mp="85ujnspgu14c" />} data-id="element-12" data-mp="d2l7513lnyzs" />
            <Route path="/contacto" element={<ContactPage data-id="element-15" data-mp="86cld4uwd7jn" />} data-id="element-14" data-mp="86mev2f5hwu3" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-17" data-mp="3gmfvride9abo" />} data-id="element-16" data-mp="3gleaym6kt9gr" />
            <Route path="/pago-confirmado" element={<PaymentConfirmedPage data-id="element-19" data-mp="3bmjsxmgfnoxp" />} data-id="element-18" data-mp="3glnxu0wbr0i8" />
            <Route path="/privacidad" element={<PrivacyPage data-id="element-21" data-mp="3bkgr855x47d5" />} data-id="element-20" data-mp="3bnmf5h2t937a" />
            <Route path="/terminos" element={<TermsPage data-id="element-23" data-mp="3qbzemo13x46j" />} data-id="element-22" data-mp="3qbpp11jz4z1d" />
            <Route path="/reembolsos" element={<RefundPage data-id="element-25" data-mp="3ljxvci5iud70" />} data-id="element-24" data-mp="3qdakcte44m0a" />
          </Routes>
        </SiteLayout>
      </div>
    </Router>;
}